import { render, staticRenderFns } from "./Cartao.vue?vue&type=template&id=501438a0&scoped=true&"
import script from "./Cartao.vue?vue&type=script&lang=js&"
export * from "./Cartao.vue?vue&type=script&lang=js&"
import style0 from "./Cartao.vue?vue&type=style&index=0&id=501438a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501438a0",
  null
  
)

export default component.exports